import AbstractApi from '@/api/abstracts/AbstractApi'
import ProjectOverviewApi from '@/api/services/sales/project/overview/ProjectOverviewApi'
import httpClient from '@/utilities/service/httpClient'
// Types
import { BidNumber } from '@/api/types/general/GeneralType'
import { ProjectAssociationPayloadType, ProjectCancelPayloadType } from '@/api/types/request/ProjectCancelPayloadType'
import { ProjectAssociationType, ProjectCancelType } from '@/api/types/response/ProjectCancelType'

/**
 * @property string apiEnd /api/sales/project
 */
export default class ProjectApi extends AbstractApi {
  overview(bidNumber: BidNumber): ProjectOverviewApi {
    return new ProjectOverviewApi(`${this.apiEnd}/overview/${bidNumber}`)
  }

  cancellation(payload: ProjectCancelPayloadType): Promise<ProjectCancelType> {
    return httpClient.post(`${this.apiEnd}/cancel/${payload.bidNumber.from}`, payload)
  }

  association(payload: ProjectAssociationPayloadType): Promise<ProjectAssociationType> {
    return httpClient.post(`${this.apiEnd}/cancel/${payload.bidNumber.from}/association`, payload)
  }
}
